import {createAction} from '@ngrx/store';
import {StoreTypes} from '../storeTypes.enum';

export const logout = createAction(`[${StoreTypes.Auth}] Logout request`);
